import { Navigate, useLocation } from "react-router-dom";
import { useTenant } from "@/contexts/TenantContext";

interface SubscriptionProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Componente que protege rotas que requerem assinatura ativa.
 * Redireciona para /assinaturas se não houver nenhum plano válido ativo.
 * Usa o método centralizado hasActiveSubscription() do TenantContext que verifica:
 * - subscription_status === 'active' E subscription_plan_id !== null
 * - OU tem transações ativas (não expiradas ou lifetime)
 * - OU é tipo especial (cortesia/testers) sem expiração
 */
export function SubscriptionProtectedRoute({ children }: SubscriptionProtectedRouteProps) {
  const { hasActiveSubscription, loading, transactionsLoading } = useTenant();
  const location = useLocation();

  // Aguardar carregamento dos dados do tenant E das transações
  // Isso evita redirecionamento prematuro quando os dados ainda estão carregando
  if (loading || transactionsLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Usar o método centralizado que verifica todas as condições de assinatura ativa
  // Incluindo transações ativas, planos especiais e status ativo
  if (!hasActiveSubscription()) {
    return <Navigate to="/configuracoes/assinatura" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

